export const theme = {
  bg: "#0a0b0f",
  bgRaised: "#0f1117",
  bgInset: "#13151c",
  border: "rgba(255,255,255,0.08)",
  borderHi: "rgba(201,164,104,0.6)",
  text: "#f0ece4",
  textDim: "#8a8070",
  textFaint: "#4a4640",
  gold: "#c9a468",
  goldText: "#e8c88a",
  goldSoft: "rgba(201,164,104,0.10)",
  amber: "#f5b96e",
  amberBg: "rgba(245,185,110,0.10)",
  emerald: "#34d399",
  emeraldBg: "rgba(52,211,153,0.10)",
  garnet: "#f37171",
  garnetBg: "rgba(243,113,113,0.10)",
  sapphire: "#60a5fa",
  sapphireBg: "rgba(96,165,250,0.10)",
};

export const fontDisplay = "'Inter', 'SF Pro Display', system-ui, sans-serif";
export const fontBody    = "'Inter', system-ui, sans-serif";
export const fontMono    = "'JetBrains Mono', 'Fira Mono', monospace";

export const ALL_SOURCES = [
  "LinkedIn", "Naukri", "Indeed", "Foundit", "Cutshort", "Wellfound", "Shine",
];

export const SOURCE_META = {
  LinkedIn:  { color: "#0077b5", bg: "rgba(0,119,181,0.10)" },
  Naukri:    { color: "#ef4444", bg: "rgba(239,68,68,0.10)" },
  Indeed:    { color: "#2557a7", bg: "rgba(37,87,167,0.10)" },
  Foundit:   { color: "#f97316", bg: "rgba(249,115,22,0.10)" },
  Cutshort:  { color: "#7c3aed", bg: "rgba(124,58,237,0.10)" },
  Wellfound: { color: "#0ea5e9", bg: "rgba(14,165,233,0.10)" },
  Shine:     { color: "#059669", bg: "rgba(5,150,105,0.10)" },
};

export const WORK_TYPE_META = {
  remote: { label: "Remote",  color: "#34d399", bg: "rgba(52,211,153,0.10)" },
  hybrid: { label: "Hybrid",  color: "#f5b96e", bg: "rgba(245,185,110,0.10)" },
  office: { label: "On-site", color: "#60a5fa", bg: "rgba(96,165,250,0.10)" },
  any:    { label: "Any",     color: "#8a8070", bg: "rgba(138,128,112,0.10)" },
};